<template>
    <div class="material-management">
        <div class="upload-view" @click="openUploadMaterialDialog()">
            <div>
                <i class="el-icon-upload2"></i>上传素材
                <span>高曝光度、高收益、高分成、便捷提现</span>
            </div>
        </div>
        <div class="material-view">
            <div class="material-types">
                <template v-for="item in types">
                    <div
                        class="material-type"
                        :class="{ active: item.value === listParams.auditstatus }"
                        v-if="item.value != 9 && item.value != 3"
                        :key="item.value"
                        @click="handleTypeChange(item.value)"
                    >
                        {{ item.text }} <span v-if="item.total > -1">（{{ item.total }}）</span>
                    </div>
                </template>
            </div>
            <div class="material-searchbar">
                <el-input
                    class="keyowrd"
                    size="small"
                    v-model="listParams.searchtext"
                    placeholder="请输入关键字"
                    @input="handleSearch()"
                >
                    <i class="el-icon-search" slot="prefix"> </i>
                </el-input>
            </div>
            <div v-show="listData.total">
                <div class="material-list" ref="list">
                    <div
                        class="material-item"
                        v-for="(item, index) in listData.list"
                        @click="listItemClick(item)"
                        :key="index"
                    >
                        <div class="material-cover">
                            <img :src="item.thumbnailurl" alt="封面"/>
                        </div>
                        <div class="material-info">
                            <div class="material-title" :title="item.materialtitle ">{{ item.materialtitle }}</div>
                            <div class="material-cells">
                                <div class="material-cell"
                                     v-if="listParams.auditstatus == 1 || listParams.auditstatus == 2"
                                     :title="'素材类别：'+item.materialtypename">
                                    素材类别：{{ item.materialtypename }}
                                </div>
                                <div class="material-cell"
                                     :title="'素材价格：'+item.saleprice"
                                >素材价格：{{ item.saleprice }}元
                                </div>
                                <div class="material-cell"
                                     :title="'购买量：'+item.purchasecount"
                                     v-if="listParams.auditstatus != 1 && listParams.auditstatus != 2">
                                    购买量：{{ item.purchasecount }}
                                </div>
                                <div class="material-cell"
                                     :title="'保存时间：'+item.releasedate"
                                     v-if="listParams.auditstatus == 1">
                                    保存时间：{{ item.releasedate }}
                                </div>
                                <div class="material-cell"
                                     :title="'提交时间：'+item.submitdate"
                                     v-if="listParams.auditstatus == 2">
                                    提交时间：{{ item.submitdate }}
                                </div>
                                <div class="material-cell"
                                     :title="'审核时间：'+item.auditpassdate"
                                     v-if="listParams.auditstatus == 4">
                                    审核时间：{{ item.auditpassdate }}
                                </div>
                                <div class="material-cell"
                                     :title="'上架时间：'+item.auditpassdate"
                                     v-if="listParams.auditstatus == 5">
                                    上架时间：{{ item.auditpassdate }}
                                </div>
                                <div class="material-cell"
                                     :title="'下架时间：'+item.removedate"
                                     v-if="listParams.auditstatus == 6">
                                    下架时间：{{ item.removedate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="loading"
                    :class="{
                        animate: listData.list.length < listData.total
                    }"
                    v-show="loading"
                >
                    <span>
                        {{ loadingText }}
                    </span>
                </div>
            </div>
            <div v-show="!listData.total && listData.isLoad" class="none-data-box">
                <div class="none-data">
                    暂无数据
                </div>
            </div>
        </div>
        <el-dialog
            title="上传素材"
            :visible.sync="uploadMaterialDialog.show"
            width="900px"
            custom-class="upload-material-dialog"
            append-to-body
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :before-close="closeUploadMaterialDialog"
            destroy-on-close
        >
            <upload-material-dialog
                v-if="uploadMaterialDialog.show"
                :guid="uploadMaterialDialog.guid"
                @closeDialog="closeUploadMaterialDialog"
            ></upload-material-dialog>
        </el-dialog>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import UploadMaterialDialog from './upload-material-dialog.vue';

export default {
    name: 'MaterialManagement',
    components: {
        UploadMaterialDialog
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.handleScroll();
            }
        }
    },
    data() {
        return {
            types: [],
            listParams: {
                auditstatus: '',
                pageindex: 0,
                pagesize: 12,
                searchtext: ''
            },
            listData: {
                list: [],
                total: 0,
                isLoad: false
            },
            loading: true,
            uploadMaterialDialog: {
                show: false,
                guid: ''
            },
            timer: false
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
        loadingText() {
            return this.listData.list.length < this.listData.total ? '正在加载' : '没有更多数据了';
        }
    },
    mounted() {
        this.getStatus();
        // 添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        // 组件销毁时移除滚动事件监听
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleTypeChange(value) {
            this.listParams.auditstatus = value;
            this.refreshList();
        },
        handleSearch() {
            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.refreshList();
            }, 500);
        },
        refreshList() {
            this.listParams.pageindex = 0;
            this.listData.list = [];
            this.$nextTick(() => {
                this.getList();
            });
        },
        getStatus() {
            this.$Api.getIncomeGeneralizationStatus().then((data) => {
                this.types = data;
                if (!this.listParams.auditstatus) {
                    this.listParams.auditstatus = this.types[0].value;
                }
                this.getList();
            });
        },
        getList() {
            this.loading = true;
            let params = {
                relationguid: this.userInfo.userguid,
                ...this.listParams
            };
            this.$Api.getIncomeGeneralizationList(params).then((data) => {
                this.loading = false;
                this.listData.list = this.listData.list.concat(data.materiallist);
                this.listData.total = data.pageinfo.totalnumcount;
                this.listData.isLoad = true;
                data.statustotal &&
                data.statustotal.forEach((item) => {
                    this.types.forEach((type) => {
                        if (type.value == item.value) {
                            type.total = item.total;
                        }
                    });
                });
                this.$nextTick(() => {
                    this.handleScroll();
                });
            });
        },
        handleScroll() {
            if (!this.visible) {
                return false;
            }

            // 获取页面滚动位置
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            const scrollHeight = document.documentElement.scrollHeight;

            // 判断是否滚动到底部（距离底部20px时触发）
            if (scrollHeight - scrollTop - clientHeight <= 32) {
                // 如果还有更多数据
                if (!this.loading && this.listData.list.length < this.listData.total) {
                    this.listParams.pageindex++;
                    this.getList();
                } else {
                    this.loading = true;
                }
            }
        },
        listItemClick({materialguid}) {
            this.openUploadMaterialDialog(materialguid);
        },
        openUploadMaterialDialog(guid = '') {
            this.uploadMaterialDialog.guid = guid;
            this.uploadMaterialDialog.show = true;
        },
        closeUploadMaterialDialog() {
            this.uploadMaterialDialog.show = false;
            this.uploadMaterialDialog.guid = '';
            this.refreshList();
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/material-management.scss';
</style>
